import axios from 'axios';
import querystring from 'querystring'
import Vue from 'vue';
import { Toast } from 'mint-ui';
import router from 'alias_router';
import urls from '@/config/urls';

const baseUrl = urls.getBaseUrl();

//拦截请求
axios.interceptors.request.use(function (config) {
    config.headers =  Object.assign({}, config.headers || {}, {
        'client': '2',
        token: localStorage.token
    })
    if(((config.method || '').toLowerCase() === 'post' ||(config.method || '').toLowerCase() === 'put'
    ||(config.method || '').toLowerCase() === 'patch' ) && config.data && !config.headers['Content-Type']){
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config.data = querystring.stringify(config.data);
    }

    if(config.url.indexOf('?') < 0){
        config.url+='?_='+new Date().getTime()
    }else{
        config.url+='&_='+new Date().getTime()
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

//拦截响应
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    if (response.data.status === -1) {
        sessionStorage.removeItem('token')
        window.location.replace('/')
    }

    const errortext = response.statusText;
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
}


//存储正在请求中的ajax
var AJATOKEN = {}
function compileAjaxToken(option){
    option = option || {};
    var token = option.url+option.method+JSON.stringify(option.data || option.params || {});
    return token;
}
var http = function(option, token) {

    //判断重复请求
    var donotRepeat = option.doNotRepeat === void 0 ? true : option.doNotRepeat;
    if(donotRepeat){
        if(AJATOKEN[token]){
            var then = {
                then: function(){
                    return then;
                },
                catch: function(){

                }
            }
            return then;
        }
        AJATOKEN[token] = true;
    }
    option.headers = option.headers || {};
    if(option.showLoading !== false){
        Vue.$vux.loading.show("请求中")
    }
    return axios(option).then(checkStatus).then((res) => {
        delete AJATOKEN[token];
        Vue.$vux.loading.hide()
        if (!res.data.hasOwnProperty('status') && res.data) {
            return Promise.resolve({
                status: 0,
                msg: '请求成功',
                data: res.data||{},
                fullData: res.data
            })
        }else if (res.data.status === '0' || res.data.key || res.data.hash) {
            localStorage.setItem('isPull',1)
            return Promise.resolve({
                status: res.data.status,
                data: res.data.msg,
                fullData: res.data
            })
        }else if(res.data.status === '4'){
          Vue.$vux.toast.text(res.data.data.err_code_des);
          return Promise.reject({
            status: res.data.status,
            msg: res.data.message,
            data: res.data.data,
            fullData: res.data
          })
        }else{
              if (res.data.status === '9') {
                localStorage.removeItem('token');
                // router.push('/login');
              }
              Vue.$vux.toast.text(res.data.msg || '请求异常!');
              return Promise.reject({
                status: res.data.status,
                msg: res.data.message,
                data: res.data.data||{},
                fullData: res.data
            })
        }
    })
}

function request(option){
    option = option || {};
    var token = compileAjaxToken(option);
    var promise = http(option, token);
    setTimeout(()=>{
        promise.catch((error) => {
            console.log(2222,error)
            delete AJATOKEN[token];
            Vue.$vux.loading.hide()
            if(error.status === void 0){
                // Vue.$vux.toast.text('系统出现故障了，请稍后再试');
            }
            return {}
        })
    })
    return promise;
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/comm/request.js